import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { ArrowBack as BackIcon, Construction as ConstructionIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import './ComingSoon.css';

interface ComingSoonProps {
  title?: string;
  description?: string;
  showBackButton?: boolean;
}

const ComingSoon: React.FC<ComingSoonProps> = ({
  title = "Coming Soon",
  description = "This feature will be available in a future update. We're working hard to bring you the best experience.",
  showBackButton = true
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Box className="coming-soon-page">
      <Container maxWidth="md" className="coming-soon-container">
        <Box className="coming-soon-content">
          <ConstructionIcon className="construction-icon" />
          
          <Typography variant="h3" className="coming-soon-title">
            {title}
          </Typography>
          
          <Typography variant="h6" className="coming-soon-description">
            {description}
          </Typography>
          
          <Typography variant="body1" className="coming-soon-subtitle">
            Thank you for your patience as we continue to improve our application.
          </Typography>
          
          {showBackButton && (
            <Button
              variant="contained"
              startIcon={<BackIcon />}
              onClick={handleBack}
              className="back-button"
              size="large"
            >
              Go Back
            </Button>
          )}
        </Box>
      </Container>
    </Box>
  );
};

export default ComingSoon;
